import axios from 'axios'

const getBaseApiURL = () => { return axios.defaults.baseURL }
const authApiURL = 'authOp.php'
const printerApiURL = 'printer.php'

const documentTypes = [
  { code: 'P', label: 'Passport' },
  { code: 'C', label: 'National Identity Card' },
  { code: 'M', label: 'Military Identification' },
  { code: 'D', label: 'Diplomatic Passport/Card' },
  { code: 'G', label: 'Group Passport' }
]

export {
  getBaseApiURL,
  authApiURL,
  printerApiURL,
  documentTypes
}
